import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, MARKS} from '@contentful/rich-text-types'
import {SectionIntro} from '@primer/react-brand'
import type {PrimerComponentSectionIntro} from '../../../lib/types/contentful'

export type ContentfulSectionIntroProps = {
  component: PrimerComponentSectionIntro
}

export function ContentfulSectionIntro({component}: ContentfulSectionIntroProps) {
  return (
    <SectionIntro align={component.fields.align} fullWidth={component.fields.fullWidth}>
      {typeof component.fields.heading === 'string' ? (
        <SectionIntro.Heading>{component.fields.heading}</SectionIntro.Heading>
      ) : (
        documentToReactComponents(component.fields.heading, {
          renderMark: {
            /**
             * We use <em> to benefit from Primer Brand's special styling for <em> tags:
             * https://primer.style/brand/components/SectionIntro#emphasized-text
             */
            [MARKS.BOLD]: text => <em>{text}</em>,
          },
          renderNode: {
            [BLOCKS.PARAGRAPH]: (_, children) => <SectionIntro.Heading>{children}</SectionIntro.Heading>,
          },
        })
      )}

      {component.fields.description !== undefined
        ? documentToReactComponents(component.fields.description, {
            renderNode: {
              [BLOCKS.PARAGRAPH]: (_, children) => <SectionIntro.Description>{children}</SectionIntro.Description>,
            },
          })
        : null}

      {component.fields.link !== undefined && (
        <SectionIntro.Link href={component.fields.link.fields.href}>
          {component.fields.link.fields.text}
        </SectionIntro.Link>
      )}
    </SectionIntro>
  )
}

try{ ContentfulSectionIntro.displayName ||= 'ContentfulSectionIntro' } catch {}